import React from "react";
import { useState, useEffect } from "react";
import { EncryptStorage } from "encrypt-storage";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftIcon, EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { ROUTES } from "Route/ConstantRoute";
import { handleError } from "Helper";

function UpdateUser() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState(argumentData?.user_full_name || "");
  const [email, setEmail] = useState(argumentData?.email || "");
  const [phone, setPhoneNumber] = useState(argumentData?.phone || "");
  const [statusData, setStatusData] = useState(
    argumentData?.active !== undefined
      ? argumentData?.active === true
        ? "Aktif"
        : "Non-Aktif"
      : ""
  );
  const [jenisKelamin, setJenisKelamin] = useState(
    argumentData?.user_gender_id || ""
  );
  const [uuid] = useState(argumentData?.id || "");
  const [permissionGroup, setPermissionGroup] = useState(
    argumentData?.user_permission_id || ""
  );
  const [organization, setOrganization] = useState(
    argumentData?.user_organization_id || ""
  );

  // State untuk menampul array response
  const [dataGender, setDataGender] = useState([]);
  const [dataPermission, setDataPermission] = useState([]);
  const [dataOrganization, setDataOrganization] = useState([]);

  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const handleWarning = (error) => {
    Notify.warning({
      title: "Peringatan",
      description: error,
    });
  };
  const goBack = () => {
    navigate(ROUTES.management_data.user_access.user_access_home);
  };
  const getDataGender = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/gender/get-list`);
      setDataGender(response.data?.data);
      getDataPermission();
    } catch (err) {
      setDataGender([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const getDataPermission = async () => {
    try {
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const response = await fetchApi().get(
        `/permission-group/get-list?${paramPage}&${paramSize}`
      );
      setDataPermission(response.data?.data);
      getDataOrganization();
    } catch (err) {
      setDataPermission([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const getDataOrganization = async () => {
    try {
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const response = await fetchApi().get(
        `/organization/get-list?${paramPage}&${paramSize}`
      );
      setDataOrganization(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataOrganization([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const updateData = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        email: email,
        fullName: fullName,
        phone: phone,
        password: password,
        confirmPassword: confirmPassword,
        user_gender_id: jenisKelamin,
        user_organization_id: organization,
        user_permission_id: permissionGroup,
        is_active: statusData === "Aktif" ? true : false,
      };
      const response = await fetchApi().put(`/auth/update/${uuid}`, reqBody);
      setIsLoading(false);
      const userName = reqBody.fullName;
      handleSuccess(`Pengguna ${userName} Berhasil Diperbarui`);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (confirmPassword === password) {
      updateData();
    } else {
      handleWarning("Konfirmasi Kata Sandi Tidak Sama");
    }
  };

  useEffect(() => {
    getDataGender();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Ubah Data Pengguna
        </p>
      </div>
      <form className="" onSubmit={handleSubmitForm}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>
          {/* Kolom Pertama */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="full_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Lengkap
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="full_name"
                  name="full_name"
                  type="text"
                  value={fullName}
                  placeholder="Masukkan Nama Lengkap"
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="email"
                className="flex block text-sm font-medium leading-6"
              >
                Email
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="text"
                  value={email}
                  placeholder="Masukkan Email Anda"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Kolom Pertama */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="phone_number"
                className="flex block text-sm font-medium leading-6"
              >
                Nomor Handphone
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="phone_number"
                  name="phone_number"
                  type="text"
                  value={phone}
                  placeholder="Masukkan Nomor Handphone"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="jenis_kelamin"
                className="flex block text-sm font-medium leading-6"
              >
                Jenis Kelamin
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="jenis_kelamin"
                    name="jenis_kelamin"
                    required
                    value={jenisKelamin}
                    onChange={(e) => setJenisKelamin(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Jenis Kelamin
                    </option>
                    {dataGender.map((item) => (
                      <option value={item.id}>{item.gender_name}</option>
                    ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Kolom Pertama */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="permission_roles"
                className="flex block text-sm font-medium leading-6"
              >
                Izin Akses
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="permission_roles"
                    name="permission_roles"
                    required
                    value={permissionGroup}
                    disabled={isLoading}
                    onChange={(e) => setPermissionGroup(e.target.value)}
                    className={`h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Izin Akses
                    </option>
                    {dataPermission.map((item) => (
                      <option value={item.id}>{item.permission_name}</option>
                    ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="organization"
                className="flex block text-sm font-medium leading-6"
              >
                Organisasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="organization"
                    name="organization"
                    required
                    disabled={yuridiksi_user_code !== "N" ? true : false}
                    value={organization}
                    onChange={(e) => setOrganization(e.target.value)}
                    className={`${
                      yuridiksi_user_code !== "N" ? "bg-zinc-100" : ""
                    } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Organisasi Anda
                    </option>
                    {dataOrganization.map((item) => (
                      <option value={item.id}>{item.organization_name}</option>
                    ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Kolom Pertama */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="password"
                className="flex block text-sm font-medium leading-6"
              >
                Kata Sandi Baru
              </label>
              <div className="mt-2 relative">
                <input
                  id="password"
                  name="password"
                  placeholder="Masukkan Kata Sandi Saat Ini"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 pr-10"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer text-gray-600"
                >
                  {showPassword ? (
                    <EyeOffIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="konfirmasi_kata_sandi"
                className="block text-sm font-medium leading-6"
              >
                Konfirmasi Kata Sandi Baru
              </label>
              <div className="mt-2 relative">
                <input
                  id="confirm_password_input"
                  name="confirm_password_input"
                  placeholder="Konfirmasi Kata Sandi Saat Ini"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 pr-10"
                />
                <button
                  type="button"
                  onClick={toggleConfirmPasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer text-gray-600"
                >
                  {showConfirmPassword ? (
                    <EyeOffIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Kolom Pertama */}
          <div className="flex justify-end items-center py-5 px-5 w-full">
            <div className="mb-2 w-full">
              <label
                htmlFor="status_data"
                className="flex block text-sm font-medium leading-6"
              >
                Status Akun Pengguna
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="status_data"
                    name="status_data"
                    required
                    value={statusData}
                    disabled={isLoading}
                    onChange={(e) => setStatusData(e.target.value)}
                    className={`h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status Akun
                    </option>
                    <option value="Aktif">Aktif</option>
                    <option value="Non-Aktif">Non-Aktif</option>
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan Perubahan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdateUser;
